import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import user from "../../Assets/Image/admin/user.png";
import deletes from "../../Assets/Image/admin/delete.png";
import view from "../../Assets/Image/admin/view.png";
import Dialog from "../../Base-Component/Dialog/Dialog";
import noImage from "../../Assets/Image/admin/user.png";
import back from "../../Assets/Image/admin/background3.png";
import { useDebounce } from "use-debounce";
import moment from "moment/moment";
import { Shield, ShieldBan } from "lucide-react";
import { useFormik } from "formik";
import { blockUnblockUser, deleteUsers, getAlluser, getBlockAlluser } from "../../Services/ApiServices";
import toast from "react-hot-toast";
import { IMG_URL } from "../../Services/Api";
import * as Yup from "yup";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaCaretUp, FaSort, FaSortDown } from 'react-icons/fa';

function Users() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const menuRef = useRef(null);
  const location = useLocation();

  const [isDragging, setIsDragging] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isBlockUser, setIsBlockUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [totalPage, setTotalPage] = useState("1");
  const [userId, setUserId] = useState({});
  const [dialogType, setDialogType] = useState("");
  const [isUnblock, setIsUnblock] = useState(false);
  const [userData, setUserData] = useState([]);
  const [search] = useDebounce(searchData, 1000);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [openMenuIndex, setOpenMenuIndex] = useState(null);

  const flag = location.state?.flag ?? 0;

  const handleUserList = () => {
    setLoader(true);
    let obj = { page: pageNo };

    if (search) {
      obj.search = search;
    }

    const fetchData = flag === 0 ? getAlluser : getBlockAlluser;

    fetchData(obj)
      .then((res) => {
        setTotalPage(res?.data?.pagination?.totalPages);
        setLoader(false);
        setUserData(res?.data?.data || []);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  const handleSearchChange = (e) => {
    setSearchData(e.target.value);
    setPageNo(1);
  };

  useEffect(() => {
    handleUserList();
  }, [pageNo, search]);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  const sortedData = [...userData].sort((a, b) => {
    if (!sortColumn) return 0;

    let valueA = a[sortColumn] ? a[sortColumn].toString().toLowerCase() : "";
    let valueB = b[sortColumn] ? b[sortColumn].toString().toLowerCase() : "";

    if (sortColumn === "name") {
      valueA = `${a.firstname || ""} ${a.lastname || ""}`.trim().toLowerCase();
      valueB = `${b.firstname || ""} ${b.lastname || ""}`.trim().toLowerCase();
    }

    if (sortColumn === "email_id") {
      valueA = a.email_id ? a.email_id.toLowerCase() : "";
      valueB = b.email_id ? b.email_id.toLowerCase() : "";
    }

    if (sortColumn === "phone_number") {
      valueA = a.phone_number || "";
      valueB = b.phone_number || "";
    }

    if (sortColumn === "createdAt") {
      valueA = new Date(a.createdAt);
      valueB = new Date(b.createdAt);
      return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
    }

    if (sortColumn === "id") {
      valueA = Number(a.id) || 0;
      valueB = Number(b.id) || 0;
      return sortOrder === "asc" ? valueA - valueB : valueB - valueA;
    }

    return sortOrder === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
  });


  const renderPaginationButtonss = () => {
    const maxPagesToShow = 3;
    const buttons = [];
    const startPage = Math.max(1, pageNo - Math.floor(maxPagesToShow / 2));
    const endPage = Math.min(totalPage, startPage + maxPagesToShow - 1);

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={
            i === pageNo
              ? "px-4 py-[7px] mx-1 bg-[#EA5F5F1A] rounded-md text-[#EA5F5F]"
              : "px-4 py-[7px] mx-1 text-[#EA5F5F]"
          }
        >
          {i}
        </button>
      );
    }
    return buttons;
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPage) {
      setPageNo(page);
    }
  };

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleViewAction = (data, action) => {
    setUserId(data);

    if (action === "block") {
      setDialogType("block");
      setIsBlockUser(true);
    } else if (action === "unblock") {
      setDialogType("unblock");
      setIsUnblock(true);
    } else if (action === "delete") {
      setDialogType("delete");
      setModalOpens(true);
    }
  };

  const validationSchema = Yup.object().shape({
    reason: Yup.string()
      .trim()
      .required("Reason is required")
  });

  const formik = useFormik({
    initialValues: {
      reason: ''
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      setIsLoading(true);

      if (dialogType === "block") {
        let obj = {
          user_id: userId?.id,
          reason: values?.reason,
        };

        blockUnblockUser(obj)
          .then((res) => {
            if (res?.status === 200) {
              toast.success(res?.data?.message);
              handleUserList();
              resetForm();
            }
            setIsBlockUser(false)
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message);
            setIsLoading(false);
          });
      } else if (dialogType === "delete") {
        let obj = {
          user_id: userId?.id,
          reason: values?.reason,
        };

        deleteUsers(obj)
          .then((res) => {
            if (res?.status === 200) {
              toast.success(res?.data?.message);
              handleUserList();
              resetForm();
            }
            setModalOpens(false);
            setIsLoading(false);
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message);
            setIsLoading(false);
          });
      }
    }
  });

  const handleDeleteClose = () => {
    setModalOpens(false);
    formik?.resetForm();
  };

  const handleUnblock = () => {
    setIsLoading(true);
    let obj = {
      user_id: userId?.id,
    };

    blockUnblockUser(obj)
      .then((res) => {
        if (res?.status === 200) {
          toast.success(res?.data?.message);
          handleUserList();
        }
        setIsUnblock(false);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsLoading(false);
      });
  };

  const columns = [
    { key: "id", label: "USER ID" },
    { key: "name", label: "USER" },
    { key: "email_id", label: "EMAIL" },
    { key: "phone_number", label: "PHONE NUMBER" },
    { key: "login_type", label: "LOGIN TYPE" },
    { key: "createdAt", label: "JOIN DATE" },
  ];

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenuIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="grid grid-cols-12 md:m-4 m-1 fontNew">
        <div className="col-span-12 duration-300 cursor-pointer">
          <div className="flex justify-end mb-4 items-start">
            <div className="flex xl:w-70 sm:w-52 w-full h-10 px-4 sm:mb-0 mb-3 rounded-[8px] bg-white items-center">
              <input
                type="text"
                required
                className="bg-transparent sm:w-70 w-full border-none outline-none h-10 text-sm fontNew"
                placeholder="Search..."
                name="search_text"
                value={searchData}
                onChange={handleSearchChange}
              />
            </div>
          </div>
        </div>
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#FF4433"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {userData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <>
                <div className="col-span-12 overflow-x-auto">
                  <div
                    className="w-full"
                    onMouseDown={startDragging}
                    onMouseLeave={stopDragging}
                    onMouseUp={stopDragging}
                    onMouseMove={onDragging}
                    ref={scrollRef}
                  >
                    <table className="w-full border-separate border-spacing-y-3">
                      <thead>
                        <tr className="bg-white">
                          {columns.map(({ key, label }) => (
                            <th
                              key={key}
                              className={`py-4 px-2 text-base font-medium whitespace-nowrap text-start cursor-pointer ${key === "id" && "pl-4"}`}
                              onClick={() => handleSort(key)}
                            >
                              {label}
                              <span className="inline-block ml-1">
                                {sortColumn === key ? (
                                  sortOrder === "asc" ? <FaSortDown className="inline-block" /> : <FaCaretUp className="inline-block" />
                                ) : (
                                  <FaSort className="inline-block text-gray-400" />
                                )}
                              </span>
                            </th>
                          ))}
                          <th className="py-4 px-5 text-base h-full font-medium whitespace-nowrap text-center">
                            ACTION
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedData.map((item, index) => {
                          return (
                            <tr key={index} className="font-medium bg-white rounded-lg">
                              <td className="text-start px-4 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base font-normal">{item.id || "-"}</p>
                                </div>
                              </td>
                              <td className="text-start px-2 py-3 first:rounded-l-lg last:rounded-r-lg">
                                <div className="whitespace-nowrap w-52 flex items-center">
                                  <img
                                    src={
                                      item.profile_image ? IMG_URL + item.profile_image : user
                                    }
                                    className="w-10 h-10 rounded-full object-cover"
                                    alt=""
                                  />
                                  <p className="text-base font-normal ms-2">
                                    {item.firstname ? item?.firstname.charAt(0).toUpperCase() + item?.firstname.slice(1) : "-"}{" "}
                                    {item.lastname ? item?.lastname.charAt(0).toUpperCase() + item?.lastname.slice(1) : ""}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start px-2  py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base font-normal">
                                    {item.email_id || "-"}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start px-2  py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base font-normal">
                                    {item.country_code}{" "}
                                    {item.phone_number || "-"}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start px-2  py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base font-normal">
                                    {item?.login_type || "-"}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start px-2 py-3 first:rounded-l-lg last:rounded-r-lg ">
                                <div className="whitespace-nowrap lg:break-all break-normal">
                                  <p className="text-base font-normal">
                                    {moment(item.createdAt).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </p>
                                </div>
                              </td>
                              <td className="text-start px-2 py-3 h-full first:rounded-l-lg last:rounded-r-lg">
                                <div className="relative flex justify-center" ref={menuRef}>
                                  <div className="" onClick={() => toggleMenu(index)}><BsThreeDotsVertical className="text-xl" /></div>
                                  {openMenuIndex === index && (
                                    <div ref={menuRef} className="absolute cursor-pointer right-[40%] top-10 w-52 px-3 py-1 bg-white shadow-lg rounded-lg z-50">
                                      <div
                                        className="hover:bg-gray-50 border-b border-gray-100 text-[#303438] flex justify-between items-center py-2"
                                        onClick={() => {
                                          navigate(`/user_details/${item.id}`);
                                        }}
                                      >
                                        <div className="flex items-center">
                                          <img
                                            src={view}
                                            className="lg:w-9 w-8"
                                            alt="view"
                                          />
                                          <p className="m-0 ms-3">View Details</p>
                                        </div>
                                      </div>
                                      <div
                                        className="hover:bg-gray-50 text-[#303438] border-b border-gray-100 flex justify-between items-center py-2"
                                        onClick={() => handleViewAction(item, item?.is_blocked === false ? "block" : "unblock")}
                                      >
                                        <div className="flex items-center">
                                          {item?.is_blocked === false ? (
                                            <div className="bg-[#5570F129] w-9 h-9 rounded-full flex items-center justify-center">
                                              <ShieldBan color="#5570F1" size={17} />
                                            </div>
                                          ) : (
                                            <div className="bg-[#0000ff24] w-9 h-9 rounded-full flex items-center justify-center">
                                              <Shield color="blue" size={17} />
                                            </div>
                                          )}
                                          <p className="m-0 ms-3">{item?.is_blocked === false ? "Blocked" : "UnBlocked"}</p>
                                        </div>
                                      </div>
                                      <div
                                        className="hover:bg-gray-50 border-b border-gray-100 text-[#303438] flex justify-between items-center py-2"
                                        onClick={() => handleViewAction(item, "delete")}
                                      >
                                        <div className="flex items-center">
                                          <img
                                            src={deletes}
                                            className="lg:w-9 w-8"
                                            alt="Delete"
                                          />
                                          <p className="m-0 ms-3">Delete</p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-span-12 flex flex-wrap items-center sm:justify-end justify-center bg-white py-4 sm:px-8 px-0 rounded-lg">
                  <div className="flex items-center cursor-pointer">
                    <p
                      onClick={() => handlePageChange(pageNo - 1)}
                      disabled={pageNo === 1}
                    >
                      Previous
                    </p>
                    <div className="flex items-center mx-6">
                      {renderPaginationButtonss()}
                    </div>
                    <p
                      onClick={() => handlePageChange(pageNo + 1)}
                      disabled={pageNo === totalPage}
                    >
                      Next
                    </p>
                  </div>
                </div>
              </>
            )}
          </>
        )}
      </div>

      <Dialog open={isBlockUser} onClose={() => setIsBlockUser(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center  my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl text-center font-semibold text-black mt-6">
                  Block User?
                </h4>
                <form onSubmit={formik?.handleSubmit}>
                  <div className="my-3">
                    <label className="text-base">Reason :</label>
                    <textarea
                      name="reason"
                      value={formik.values.reason}
                      rows={5}
                      className={`bg-transparent px-4 pt-2 rounded-xl border-2 w-full outline-secondary text-base mt-2 ${formik.errors.reason && formik.touched.reason
                        ? "border-red-500"
                        : "border-slate-300"
                        }`}
                      placeholder="Enter the reason"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.reason && formik.touched.reason && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.reason}
                      </p>
                    )}
                  </div>
                  <div className="mt-7 flex items-center mb-5">
                    <button
                      className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                      onClick={() => setIsBlockUser(false)}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="bg-primary h-[50px] sm:w-36 w-30 text-sm disabled:bg-red-400 rounded-xl sm:mx-3 mx-2 text-white"
                    >
                      {isLoading ? (
                        <div className="flex justify-center">
                          <Circles
                            width={25}
                            height={25}
                            color="#fff"
                            ariaLabel="circles-loading"
                            wrapperStyle={{}}
                            visible={true}
                            wrapperClass=""
                          />
                        </div>
                      ) : (
                        "Block"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isUnblock}
        onClose={() => setIsUnblock(false)}
        size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center  my-4 sm:px-16 px-4 fontNew">

              <div>
                <h4 className="text-xl text-center font-semibold text-black mt-6">
                  UnBlock User?
                </h4>
                <p className="text-base text-gray-500 my-3">
                  Are you sure you want to unblock this User?
                </p>
                <div className="mt-7 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsUnblock(false)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    disabled={isLoading}
                    className="bg-primary h-[50px] sm:w-36 w-30 disabled:bg-red-400 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={() => handleUnblock()}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "UnBlock"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => handleDeleteClose()}
        size="md">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div>
              <img src={back} className="w-auto relative" alt="" />
              <div className="flex justify-center">
                <img
                  src={userId.profile_image ? IMG_URL + userId.profile_image : noImage}
                  className="object-cover absolute sm:w-24 sm:h-24 w-14 h-14 lg:-mt-36 md:-mt-30 sm:-mt-36 -mt-24 rounded-full border-2 "
                  alt=""
                />
              </div>
            </div>
            <div className="flex justify-center my-4 sm:px-16 px-5 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6 text-center">
                  Delete User?
                </h4>
                <form onSubmit={formik?.handleSubmit}>
                  <div className="my-3">
                    <label className="text-base">Reason :</label>
                    <textarea
                      name="reason"
                      value={formik.values.reason}
                      rows={5}
                      className={`bg-transparent px-4 pt-2 rounded-xl border-2 w-full outline-secondary text-base mt-2 ${formik.errors.reason && formik.touched.reason
                        ? "border-red-500"
                        : "border-slate-300"
                        }`}
                      placeholder="Enter the reason"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.errors.reason && formik.touched.reason && (
                      <p className="text-red-500 text-sm mt-1">
                        {formik.errors.reason}
                      </p>
                    )}
                  </div>
                  <div className="flex items-center justify-center mt-7 mb-10">
                    <button
                      type="button"
                      className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                      onClick={() => handleDeleteClose()}
                    >
                      Close
                    </button>
                    <button
                      type="submit"
                      disabled={isLoading}
                      className="bg-[#ea5f5f] h-[50px] sm:w-36 w-30 disabled:bg-red-400 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    >
                      {isLoading ? (
                        <div className="flex justify-center">
                          <Circles
                            width={25}
                            height={25}
                            color="#fff"
                            ariaLabel="circles-loading"
                            wrapperStyle={{}}
                            visible={true}
                            wrapperClass=""
                          />
                        </div>
                      ) : (
                        "Delete"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

    </>
  );
}

export default Users;
